@if (variant() === 'fields') {
  <div [class]="resolvedCardClass()" aria-hidden="true">
    @if (showHeader()) {
      <div class="lib-skeleton__header">
        <p-skeleton width="8rem" height="1rem" />
        <p-skeleton width="5rem" height="1rem" />
      </div>
    }
    <div class="lib-skeleton__grid" [style.grid-template-columns]="gridTemplateColumns()">
      @for (item of items(); track item) {
        <div class="lib-skeleton__field">
          <p-skeleton width="4.5rem" height="0.625rem" />
          <p-skeleton width="70%" height="1rem" />
        </div>
      }
    </div>
  </div>
} @else {
  @for (item of items(); track item) {
    <div [class]="resolvedCardClass()" aria-hidden="true">
      @if (showHeader()) {
        <div class="lib-skeleton__header">
          <p-skeleton width="8rem" height="1rem" />
        </div>
      }
      <div class="lib-skeleton__lines">
        @for (line of lineItems(); track line.index) {
          <p-skeleton [width]="line.width" height="0.875rem" />
        }
      </div>
    </div>
  }
}
